module.exports = __webpack_public_path__ + "img/10.e6316238.jpg";